import { MethodItem } from './types';

// TODO: update images
export const overview: MethodItem[] = [
  {
    image: '/images/network/great-partner/love-28.png',
    heading: 'You Love 28',
    copy: 'Your health has been positively transformed by using 28, and you’ve been recommending it to every woman you know.',
  },
  {
    image: '/images/network/great-partner/passionate.png',

    heading: 'Passionate',
    copy: 'You’re passionate about 28’s mission and helping women heal their hormones by working with their cycles.',
  },
  {
    image: '/images/network/great-partner/dedicated.png',
    heading: 'Dedicated',
    copy: 'You’re dedicated to your fitness and wellness and proud to share the results you’ve achieved.',
  },
  {
    image: '/images/network/great-partner/networker.png',
    heading: 'Networker',
    copy: 'You’re active on social media, especially Instagram and TikTok, and enjoy connecting with women IRL.',
  },
  {
    image: '/images/network/great-partner/entrepreneurial.png',
    heading: 'Entrepreneurial',
    copy: 'You’re entrepreneurial minded and striving to achieve financial freedom where you can work from anywhere.',
  },
];
